// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dVatRate from "../Restaumatic.Menu.V2.Types.VatRate/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ProductKey = (tag, _1) => ({tag, _1});
const compare2 = /* #__PURE__ */ (() => Data$dMaybe.ordMaybe(Restaumatic$dMenu$dV2$dTypes$dVatRate.ordVatRate).compare)();
const nameIsSymbol = {reflectSymbol: () => "name"};
const priceIsSymbol = {reflectSymbol: () => "price"};
const vatRateIsSymbol = {reflectSymbol: () => "vatRate"};
const CustomProductKeyIsSymbol = {reflectSymbol: () => "CustomProductKey"};
const CustomProductIsSymbol = {reflectSymbol: () => "CustomProduct"};
const MenuProductIsSymbol = {reflectSymbol: () => "MenuProduct"};
const MenuComboIsSymbol = {reflectSymbol: () => "MenuCombo"};
const CustomProductKey = x => x;
const CustomProduct = value0 => $ProductKey("CustomProduct", value0);
const MenuProduct = value0 => $ProductKey("MenuProduct", value0);
const MenuCombo = value0 => $ProductKey("MenuCombo", value0);
const toFillFormTypeProductKey = {fillFormDataType: v => "unknown"};
const toFillFormTypeCustomProdu = {fillFormDataType: v => "unknown"};
const newtypeCustomProductKey_ = {Coercible0: () => {}};
const hasFieldCustomProductKey = dictHasField => dictHasField;
const eqCustomProductKey = {
  eq: x => y => x.name === y.name && x.price === y.price && (() => {
    if (x.vatRate.tag === "Nothing") { return y.vatRate.tag === "Nothing"; }
    if (x.vatRate.tag === "Just") {
      if (y.vatRate.tag === "Just") {
        if (x.vatRate._1.tag === "VatA") { return y.vatRate._1.tag === "VatA"; }
        if (x.vatRate._1.tag === "VatB") { return y.vatRate._1.tag === "VatB"; }
        if (x.vatRate._1.tag === "VatC") { return y.vatRate._1.tag === "VatC"; }
        if (x.vatRate._1.tag === "VatD") { return y.vatRate._1.tag === "VatD"; }
        if (x.vatRate._1.tag === "VatE") { return y.vatRate._1.tag === "VatE"; }
        if (x.vatRate._1.tag === "VatF") { return y.vatRate._1.tag === "VatF"; }
        if (x.vatRate._1.tag === "VatG") { return y.vatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })()
};
const eqProductKey = {
  eq: x => y => {
    if (x.tag === "CustomProduct") {
      if (y.tag === "CustomProduct") { return eqCustomProductKey.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "MenuProduct") {
      if (y.tag === "MenuProduct") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.eqCartProductKey.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "MenuCombo") {
      if (y.tag === "MenuCombo") { return x._1.comboId === y._1.comboId && Restaumatic$dMenu$dV2$dTypes$dCartToOrder.eq7(x._1.elements)(y._1.elements); }
      return false;
    }
    return false;
  }
};
const ordCustomProductKey = {
  compare: x => y => {
    const v = Data$dOrd.ordString.compare(x.name)(y.name);
    if (v.tag === "LT") { return Data$dOrdering.LT; }
    if (v.tag === "GT") { return Data$dOrdering.GT; }
    const v1 = Data$dOrd.ordInt.compare(x.price)(y.price);
    if (v1.tag === "LT") { return Data$dOrdering.LT; }
    if (v1.tag === "GT") { return Data$dOrdering.GT; }
    return compare2(x.vatRate)(y.vatRate);
  },
  Eq0: () => eqCustomProductKey
};
const ordProductKey = {
  compare: x => y => {
    if (x.tag === "CustomProduct") {
      if (y.tag === "CustomProduct") { return ordCustomProductKey.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "CustomProduct") { return Data$dOrdering.GT; }
    if (x.tag === "MenuProduct") {
      if (y.tag === "MenuProduct") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ordCartProductKey.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "MenuProduct") { return Data$dOrdering.GT; }
    if (x.tag === "MenuCombo") {
      if (y.tag === "MenuCombo") { return Restaumatic$dMenu$dV2$dTypes$dCartToOrder.ordCartComboKey.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqProductKey
};
const genericProductKey = {
  to: x => {
    if (x.tag === "Inl") { return $ProductKey("CustomProduct", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $ProductKey("MenuProduct", x._1._1); }
      if (x._1.tag === "Inr") { return $ProductKey("MenuCombo", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "CustomProduct") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "MenuProduct") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "MenuCombo") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const genericCustomProductKey = {to: x => x, from: x => x};
const showCustomProductKey = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ name: " + Data$dShow.showStringImpl(v.name) + ", price: " + Data$dMoney$dRounded.toString(v.price) + (() => {
          if (v.vatRate.tag === "Just") { return ", vatRate: (Just " + Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v.vatRate._1) + ") "; }
          if (v.vatRate.tag === "Nothing") { return ", vatRate: Nothing "; }
          $runtime.fail();
        })() + "}"
      ]
    })(CustomProductKeyIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showProductKey = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [showCustomProductKey.show(v)]})(CustomProductIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showCartProductKey.show(v)]})(MenuProductIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dCartToOrder.showCartComboKey.show(v)]})(MenuComboIsSymbol);
    return x => {
      const $3 = genericProductKey.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeCustomProductKey = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(priceIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(vatRateIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dVatRate.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeProductKey = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(CustomProductIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => unscrambleDecodeCustomProductKey.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(MenuProductIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.unscrambleDecodeCartProductKey.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(MenuComboIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.unscrambleDecodeCartComboKey.unsafeDecode(x.contents)
    }))))(Unscramble$dGeneric.defaultOptions);
    return x => genericProductKey.to($0(x));
  })()
};
const encodeCustomProductKey = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCustomProductKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CustomProductKeyIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(vatRateIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dVatRate.encodeVatRate.encode(v2._1); }
        $runtime.fail();
      }
    }))(priceIsSymbol)({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))(nameIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeProductKey = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericProductKey)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(CustomProductIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeCustomProductKey.encode(v)), Data$dList$dTypes.Nil)
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(MenuProductIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeCartProductKey.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(MenuComboIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCartToOrder.encodeCartComboKey.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeCustomProductKey = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCustomProductKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomProductKeyIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(vatRateIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dVatRate.decodeVatRate.decode)
  })())(priceIsSymbol)({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())(nameIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeProductKey = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericProductKey)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomProductIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeCustomProductKey.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MenuProductIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.decodeCartProductKey.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MenuComboIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCartToOrder.decodeCartComboKey.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))))
};
export {
  $ProductKey,
  CustomProduct,
  CustomProductIsSymbol,
  CustomProductKey,
  CustomProductKeyIsSymbol,
  MenuCombo,
  MenuComboIsSymbol,
  MenuProduct,
  MenuProductIsSymbol,
  compare2,
  decodeCustomProductKey,
  decodeProductKey,
  encodeCustomProductKey,
  encodeProductKey,
  eqCustomProductKey,
  eqProductKey,
  genericCustomProductKey,
  genericProductKey,
  hasFieldCustomProductKey,
  nameIsSymbol,
  newtypeCustomProductKey_,
  ordCustomProductKey,
  ordProductKey,
  priceIsSymbol,
  showCustomProductKey,
  showProductKey,
  toFillFormTypeCustomProdu,
  toFillFormTypeProductKey,
  unscrambleDecodeCustomProductKey,
  unscrambleDecodeProductKey,
  vatRateIsSymbol
};
